import { IonHeader } from "@ionic/react";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "../assets/css/header.css";
import auth from "../utils/auth";

const Header = ({ isOpaque, isBlue, isDashboard }) => {
	const navRef = useRef(null);
	const [currentTab, setCurrentTab] = useState("");
	const { pathname } = useLocation();

	const isActive = (tabName) => {
		return currentTab == tabName ? "tab-underline" : "";
	};

	const handleTab = (tab) => {
		setCurrentTab(tab);
	};

	function menu_func() {
		navRef.current.style.display = "block";
	}

	function close_func() {
		navRef.current.style.display = "none";
	}

	useEffect(() => {
		// console.log(pathname) ;
		if (pathname.includes("courses")) {
			setCurrentTab("Courses");
		} else if (pathname.includes("hire")) {
			setCurrentTab("Hire from Wyden");
		} else if (pathname.includes("enterprise")) {
			setCurrentTab("For Enterprise");
		}
	}, []);

	return (
		<IonHeader>
			<header
				className={isBlue ? "header" : "header2"}
				style={{ opacity: isOpaque ? 1 : 0 }}
			>
				<div className="center_wrapper">
					<a href="/">
						<img
							src={
								!isBlue
									? `${process.env.PUBLIC_URL}/assets/blueLogo.png`
									: `${process.env.PUBLIC_URL}/assets/logo.svg`
							}
							id="header_logo"
						/>
					</a>
					<img
						src={
							isBlue
								? `${process.env.PUBLIC_URL}/assets/menu_white.png`
								: `${process.env.PUBLIC_URL}/assets/blue_menu.png`
						}
						id="menu_icon"
						onClick={menu_func}
					/>
					<nav ref={navRef}>
						<img
							src={`${process.env.PUBLIC_URL}/assets/close.png`}
							id="close_icon"
							onClick={close_func}
						/>
						<a
							href="/courses"
							className={isActive("Courses")}
							onClick={() => handleTab("Courses")}
						>
							Courses
						</a>
						<a
							href="/enterprise"
							className={isActive("For Enterprise")}
							onClick={() => handleTab("For Enterprise")}
						>
							For Enterprise
						</a>

						{auth.isAuthenticated() && !isDashboard ? (
							<a href={`/dashboard`}>
								<div
									style={
										isBlue
											? {
													backgroundImage: `url(${`${process.env.PUBLIC_URL}/assets/avatar.svg`})`,
											  }
											: {
													backgroundImage: `url(${`${process.env.PUBLIC_URL}/assets/avatar_1.svg`})`,
											  }
									}
									className="user-icon"
								>
									{" "}
								</div>{" "}
							</a>
						) : isDashboard ? (
							<a
								onClick={async () => {
									await auth.clearUserInfo();
									await auth.clearToken();
								}}
								href="/"
								id="login_btn"
							>
								{" "}
								Sign Out{" "}
							</a>
						) : (
							<a href="/auth/login" id="login_btn">
								Sign In
							</a>
						)}
					</nav>
				</div>
			</header>
		</IonHeader>
	);
};

export default Header;
